import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsContext } from "../types";

const SpaceDetailsContextsDescriptionCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsContext>) => (
  <TableSimpleCell {...cellProps}>
    <TableCellDescription description={context.description} />
  </TableSimpleCell>
);

export default SpaceDetailsContextsDescriptionCell;
